export default __webpack_public_path__ + "static/media/scrollUp.e61b1727.svg";